
	import {
		defineComponent,
		onMounted,
		ref
	} from 'vue';
	import * as echarts from 'echarts'
	export default defineComponent({
		components: {

		},
		props: {
			echartId: String,
			echartName: String, //echart标题名
			echartData: Array, //echart标题名
			options: Array, //echart标题名
		},
		setup(props, context) {
			// 声明
			let select = ref()

			// 页面渲染时加载
			onMounted(() => {
				echartInit()
			})

			// 学科占比统计 图表
			const echartInit = () => {
				var myChart = echarts.init(document.getElementById(props.echartId));
				// 指定图表的配置项和数据
				var option = {
					tooltip: {
						trigger: 'item'
					},
					legend: {
						type: 'scroll',
						orient: 'vertical',
						right: 10,
						top: 20,
						bottom: 20,
					},
					series: [{
						name: props.echartName,
						radius: ['40%', '70%'],
						center: ['25%', '50%'],
						type: 'pie',
						avoidLabelOverlap: false,
						label: {
							show: false,
							position: 'center'
						},
						labelLine: {
							show: false
						},
						data: props.echartData
					}]
				};
				// 使用刚指定的配置项和数据显示图表。
				myChart.setOption(option);
			}

			// 切换下拉框
			const change = () => {
				let data = {
					select:select.value
				}
				context.emit("search",data);
				
			}

			return {
				echartInit,
				change,
				select

			};
		},

	});
